import { OnboardingState, PhoneNumber } from './types';

const mutations = {
  SET_ONE_SUGGESTED_NUMBER(state: OnboardingState, num: string) {
    state.oneSuggestedNumber = num;
  },
  SET_SUGGESTED_NUMBERS(state: OnboardingState, numbers: string[]) {
    state.suggestedNumbers = numbers;
  },
  SET_NUMBER_SEARCH_ERROR(state: OnboardingState, error: string) {
    state.numberSearchError = error;
  },
  SET_BATCH_INDEX(state: OnboardingState, index: number) {
    state.batchIndex = index;
  },
  SET_SELECTED_NUMBER(state: OnboardingState, num: string) {
    state.selectedNumber = num;
  },
  SET_SELECTED_NUMBER_OBJECT(state: OnboardingState, numObject: PhoneNumber) {
    state.phoneNumber = numObject;
  },
  UPDATE_SELECTED_NUMBER_OBJECT(state: OnboardingState, num: PhoneNumber) {
    const prevValue = state.phoneNumber;
    state.phoneNumber = Object.assign({}, prevValue, num);
  },
  SET_ONBOARDING_STEP(state: OnboardingState, step: number) {
    state.onboardingStep = step;
  }
};

export default mutations;
